import { FC } from 'react';
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  HStack,
  PopoverBody,
  PopoverCloseButton,
  PopoverArrow,
  PopoverContent,
  Portal,
  PopoverTrigger,
  Popover,
  Button,
} from '@chakra-ui/react';
import { FaEdit, FaTrash } from 'react-icons/fa';
import { generatePath, useNavigate, useParams } from 'react-router-dom';
import { ROUTES } from '../../../consts/routes';
import { useAdminCardDecksServers } from '@olagg/api-hooks';
import { CardDeckServer, PermissionEnum, OlaggModule } from '@olagg/db-types';
import useRoles from '../../../features/Roles/hooks/useRoles';

interface ServersTableProps {
  servers: CardDeckServer[];
  onUpdate: () => void;
}

const ServersTable: FC<ServersTableProps> = ({ servers, onUpdate }) => {
  const navigate = useNavigate();
  const { deck_id } = useParams();
  const { missingPermission } = useRoles();
  
  if (!deck_id) return null;

  const { deleteServer } = useAdminCardDecksServers(deck_id);

  return (
    <Table
      variant="striped"
      colorScheme="olaggPurple"
      fontSize="18px"
      position='relative'
    >
      <Thead>
        <Tr>
          <Th>Server ID</Th>
          <Th>Invite URL</Th>
          <Th>Acciones</Th>
        </Tr>
      </Thead>
      <Tbody>
        {servers.map((server) => (
          <Tr key={server.id}>
            <Td>{server.serverId}</Td>
            <Td>{server.inviteUrl}</Td>
            <Td>
              <HStack spacing={2}>
              <Button size={'sm'} padding='14px 16px' colorScheme='green'
                  onClick={(e) => { e.stopPropagation(); navigate(generatePath(ROUTES.CARD_DECKS.servers.update, { deck_id, id: server.id })); }}
                  leftIcon={<FaEdit />}
                  isDisabled={missingPermission(OlaggModule.CardDeck, PermissionEnum.EDIT)}
                  >
                  Editar
                </Button>
                      
                <Popover>
                  <PopoverTrigger>
                    <Button
                      size={'sm'} padding='14px 16px' ml={0} colorScheme="red"
                      onClick={(e) => e.stopPropagation()}
                      leftIcon={<FaTrash />}
                      isDisabled={missingPermission(OlaggModule.CardDeck, PermissionEnum.DELETE)}
                    >
                      Eliminar
                    </Button>
                  </PopoverTrigger>
                  <Portal>
                    <PopoverContent>
                      <PopoverArrow />
                      <PopoverCloseButton />
                      <PopoverBody>
                        <Button width={'100%'} colorScheme='red'
                          onClick={async (e) => { e.stopPropagation(); await deleteServer(server.id); onUpdate(); }}
                        >
                          Confirmar Eliminar
                        </Button>
                      </PopoverBody>
                    </PopoverContent>
                  </Portal>
                </Popover>
              </HStack>
            </Td>
          </Tr>
        ))}
      </Tbody>
    </Table>
  );
};

export default ServersTable; 